import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../../axiosConfig';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowLeft,
  faCheck,
  faTimes,
  faCrown,
  faPercentage,
  faCalendarAlt,
  faUsers,
  faUserShield,
  faDumbbell,
  faIdCard,
  faCheckCircle,
  faInfoCircle
} from '@fortawesome/free-solid-svg-icons';
import '../../styles/UserCenter.css';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const VipSubscription = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState('balance');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [checkoutVisible, setCheckoutVisible] = useState(false);
  const [isVip, setIsVip] = useState(false);
  const [vipExpiry, setVipExpiry] = useState(null);

  // VIP计划
  const vipPlans = [
    {
      id: 1,
      name: '月度VIP',
      price: 99,
      duration: 1, // 月
      popular: false,
      features: ['预约教练8折优惠', '会员专属设施使用权', '每月5次免费团课']
    },
    {
      id: 2,
      name: '季度VIP',
      price: 259,
      duration: 3, // 月
      popular: true,
      features: ['预约教练7折优惠', '会员专属设施使用权', '每月8次免费团课', '季度健康评估']
    },
    {
      id: 3,
      name: '年度VIP',
      price: 899,
      duration: 12, // 月
      popular: false,
      features: ['预约教练6折优惠', '会员专属设施无限使用', '无限次免费团课', '专属私教一对一指导(2次/月)', '年度体能测试与健康评估']
    }
  ];

  // 会员权益
  const vipBenefits = [
    {
      icon: faPercentage,
      title: '专属折扣',
      description: '教练预约、商品购买专享会员折扣'
    },
    {
      icon: faCalendarAlt,
      title: '优先预约',
      description: '提前7天预约热门课程和教练'
    },
    {
      icon: faUsers,
      title: '免费团课',
      description: '每月固定次数免费参加团体课程'
    },
    {
      icon: faUserShield,
      title: '专业指导',
      description: '专业教练定期提供训练指导'
    },
    {
      icon: faDumbbell,
      title: '专属设施',
      description: '使用会员专区高级健身设备'
    },
    {
      icon: faIdCard,
      title: '身份象征',
      description: 'VIP专属标识和服务特权'
    }
  ];

  // 获取用户信息
  useEffect(() => {
    let storedUser = localStorage.getItem('userData');
    
    // 如果userData不存在，尝试使用user键
    if (!storedUser) {
      storedUser = localStorage.getItem('user');
      // 如果找到了user信息，同时存储到userData中以保持一致性
      if (storedUser) {
        localStorage.setItem('userData', storedUser);
      }
    }
    
    if (!storedUser) {
      navigate('/login');
      return;
    }
    
    try {
      const parsedUser = JSON.parse(storedUser);
      setUserData(parsedUser);

      console.log('Parsed User Data:', parsedUser);
      
      
      // 检查用户是否已是会员
      if (parsedUser.vipLevel) {
        setIsVip(true);
        // 如果有会员到期日信息，解析并设置
        if (parsedUser.vipExpiry) {
          setVipExpiry(new Date(parsedUser.vipExpiry));
        }
      }
    } catch (err) {
      console.error('Error parsing user data', err);
      navigate('/login');
    }
  }, [navigate]);

  // 选择VIP计划
  const handleSelectPlan = (plan) => {
    // 如果用户已是会员，显示提示而不是选择计划
    if (isVip) {
      toast.info('您已是会员，可以选择续费或升级');
    }
    
    setSelectedPlan(plan);
    setCheckoutVisible(true);
  };

  // 处理支付方式选择
  const handlePaymentMethodChange = (e) => {
    setPaymentMethod(e.target.value);
  };

  // 提交购买请求
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!selectedPlan) {
      setError('请选择会员套餐');
      return;
    }

    // 检查是否有token
    const token = localStorage.getItem('token');
    if (!token) {
      toast.error('您的登录已过期，请重新登录');
      setTimeout(() => navigate('/login'), 2000);
      return;
    }

    // 如果选择余额支付，判断余额是否足够
    if (paymentMethod === 'balance' && parseFloat(userData.yue || 0) < selectedPlan.price) {
      setError('账户余额不足，请充值或选择其他支付方式');
      toast.error('账户余额不足，请充值或选择其他支付方式');
      return;
    }

    setLoading(true);
    setError('');

    try {
      // const response = await axios.post('/yonghu/purchaseVip', {
      //   userId: userData.id,
      //   vipLevel: selectedPlan.name,
      //   duration: selectedPlan.duration,
      //   amount: selectedPlan.price,
      //   paymentMethod,
      //   // 如果用户已是会员，则这是一次续费或升级操作
      //   isRenewal: isVip,
      //   zhanghao: userData.zhanghao
      // });
      const response = await axios.get(`/yonghu/purchaseVip`, {
        params: {
          zhanghao: userData.zhanghao,
          vipLevel: selectedPlan.name,
          duration: selectedPlan.duration,
          amount: selectedPlan.price,
          // paymentMethod,
          //这后端规定余额是2
          paymentMethod: paymentMethod === 'balance' ? 2 : paymentMethod === 'alipay' ? 1 : 3,
          // 如果用户已是会员，则这是一次续费或升级操作
          isRenewal: isVip
        }
      });

      if (response.data.code === 0) {
        setSuccess(true);
        toast.success(isVip ? '会员续费/升级成功！' : '会员购买成功！');
        
        // 更新本地存储的用户信息
        const vipExpiry = new Date();
        vipExpiry.setMonth(vipExpiry.getMonth() + selectedPlan.duration);
        
        const updatedUser = {
          ...userData,
          vipLevel: selectedPlan.name,
          vipExpiry: vipExpiry.toISOString(),
          vipActive: true
        };
        
        // 如果使用余额支付，更新余额
        if (paymentMethod === 'balance') {
          updatedUser.yue = (parseFloat(userData.yue || 0) - selectedPlan.price).toFixed(2);
        }
        
        localStorage.setItem('userData', JSON.stringify(updatedUser));
        localStorage.setItem('user', JSON.stringify(updatedUser));
        setUserData(updatedUser);
        setIsVip(true);
        setVipExpiry(vipExpiry);
        
        // 3秒后返回个人中心
        setTimeout(() => {
          navigate(`/users/${userData.id}`);
        }, 3000);
      } else {
        setError(response.data.msg || '购买会员失败，请稍后重试');
        toast.error(response.data.msg || '购买会员失败，请稍后重试');
      }
    } catch (err) {
      console.error('购买会员请求出错：', err);
      setError('网络错误，请稍后重试');
      toast.error('网络错误，请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  // 返回个人中心
  const handleGoBack = () => {
    if (checkoutVisible) {
      setCheckoutVisible(false);
      setSelectedPlan(null);
    } else {
      // 返回到用户详情页而不是用户中心
      if (userData && userData.id) {
        navigate(`/users/${userData.id}`);
      } else {
        navigate('/user-center');
      }
    }
  };

  // 格式化日期
  const formatDate = (date) => {
    if (!date) return '未知';
    return date.toLocaleDateString('zh-CN', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  if (!userData) {
    return <div className="loading-spinner">加载中...</div>;
  }

  return (
    <div className="user-center-container">
      <ToastContainer position="top-center" autoClose={3000} />
      <div className="page-header">
        <button className="btn btn-link" onClick={handleGoBack}>
          <FontAwesomeIcon icon={faArrowLeft} /> 
          {checkoutVisible ? '返回会员套餐选择' : '返回个人中心'}
        </button>
        <h1 className="section-title">
          <FontAwesomeIcon icon={faCrown} />
          <span>{checkoutVisible ? '确认会员订购' : (isVip ? 'VIP会员续费/升级' : 'VIP会员订阅')}</span>
        </h1>
      </div>

      {isVip && !checkoutVisible && (
        <div className="vip-status-card">
          <div className="vip-status-header">
            <FontAwesomeIcon icon={faInfoCircle} />
            <h3>您当前的会员状态</h3>
          </div>
          <div className="vip-status-content">
            <p>会员等级: <strong>{userData.vipLevel}</strong></p>
            <p>到期时间: <strong>{vipExpiry ? formatDate(vipExpiry) : '未知'}</strong></p>
            <p>您可以选择续费当前会员等级或升级到更高级别的会员</p>
          </div>
        </div>
      )}

      {success ? (
        <div className="success-message">
          <FontAwesomeIcon icon={faCheckCircle} size="3x" />
          <h2>{isVip ? '会员续费/升级成功' : '购买成功'}</h2>
          <p>您已成功{isVip ? '续费/升级' : '订阅'} {selectedPlan.name}，有效期 {selectedPlan.duration} 个月</p>
          <p>3秒后自动返回个人中心...</p>
          <button className="btn btn-primary" onClick={() => navigate(`/users/${userData.id}`)}>
            立即返回
          </button>
        </div>
      ) : checkoutVisible ? (
        <div className="vip-payment-container">
          <div className="vip-payment-header">
            <h3 className="vip-payment-title">确认订购</h3>
          </div>

          <div className="vip-payment-summary">
            <div className="vip-payment-item">会员套餐</div>
            <div className="vip-payment-value">{selectedPlan.name}</div>
          </div>

          <div className="vip-payment-summary">
            <div className="vip-payment-item">有效期</div>
            <div className="vip-payment-value">{selectedPlan.duration} 个月</div>
          </div>

          <div className="vip-payment-summary">
            <div className="vip-payment-item">价格</div>
            <div className="vip-payment-value">¥{selectedPlan.price}</div>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>支付方式</label>
              <div className="payment-methods">
                <div className="payment-method">
                  <input
                    type="radio"
                    id="balance"
                    name="paymentMethod"
                    value="balance"
                    checked={paymentMethod === 'balance'}
                    onChange={handlePaymentMethodChange}
                  />
                  <label htmlFor="balance">账户余额 (当前余额: ¥{userData.yue || '0.00'})</label>
                </div>
                <div className="payment-method">
                  <input
                    type="radio"
                    id="alipay"
                    name="paymentMethod"
                    value="alipay"
                    checked={paymentMethod === 'alipay'}
                    onChange={handlePaymentMethodChange}
                  />
                  <label htmlFor="alipay">支付宝</label>
                </div>
                <div className="payment-method">
                  <input
                    type="radio"
                    id="wechat"
                    name="paymentMethod"
                    value="wechat"
                    checked={paymentMethod === 'wechat'}
                    onChange={handlePaymentMethodChange}
                  />
                  <label htmlFor="wechat">微信支付</label>
                </div>
              </div>
            </div>

            {error && <div className="error-message"><FontAwesomeIcon icon={faTimes} /> {error}</div>}

            <div className="form-actions">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? '处理中...' : (isVip ? '确认续费/升级' : '确认购买')}
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleGoBack}
              >
                取消
              </button>
            </div>
          </form>
        </div>
      ) : (
        <>
          {/* VIP权益 */}
          <div className="vip-benefits">
            <h2 className="section-title">会员专享权益</h2>
            <div className="benefits-grid">
              {vipBenefits.map((benefit, index) => (
                <div key={index} className="benefit-card">
                  <div className="benefit-icon">
                    <FontAwesomeIcon icon={benefit.icon} />
                  </div>
                  <h3 className="benefit-title">{benefit.title}</h3>
                  <p className="benefit-description">{benefit.description}</p>
                </div>
              ))}
            </div>
          </div>

          {/* VIP套餐 */}
          <div className="vip-plans">
            <h2 className="section-title">选择会员套餐</h2>
            <div className="plans-container">
              {vipPlans.map((plan) => (
                <div
                  key={plan.id}
                  className={`plan-card ${plan.popular ? 'popular' : ''}`}
                >
                  {plan.popular && <div className="popular-badge">热门选择</div>}
                  <h3 className="plan-name">{plan.name}</h3>
                  <div className="plan-price">¥{plan.price}</div>
                  <div className="plan-duration">{plan.duration} 个月</div>
                  <ul className="plan-features">
                    {plan.features.map((feature, index) => (
                      <li key={index}>
                        <FontAwesomeIcon icon={faCheck} className="feature-check" />
                        {feature}
                      </li>
                    ))}
                  </ul>
                  <button
                    className="btn btn-primary plan-button"
                    onClick={() => handleSelectPlan(plan)}
                  >
                    {isVip ? '续费/升级' : '立即订阅'}
                  </button>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default VipSubscription;
